import { StatusBar } from 'expo-status-bar';
import React, {Component} from 'react';
import { AppRegistry, Image, StyleSheet, Text, View, Dimensions, TouchableHighlight, TouchableOpacity, ScrollView, TextInput, Linking } from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import * as WebBrowser from 'expo-web-browser';

import colors from './app/config/colors';

import PlaygroundScreen from "./app/screens/PlaygroundScreen";

import AsyncStorage from '@react-native-async-storage/async-storage';
import { unstable_renderSubtreeIntoContainer } from 'react-dom';
/*
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyABhqfp4hRIvUBw0GKyt_n-9_mjJz0wU50",
  authDomain: "math-competitions-tracker.firebaseapp.com",
  projectId: "math-competitions-tracker",
  storageBucket: "math-competitions-tracker.appspot.com",
  messagingSenderId: "1071564980167",
  appId: "1:1071564980167:web:e1860d64d8548b8ac223e2",
  measurementId: "G-6YZKK26Z3X"
};

if (firebase.apps.length == 0) {
  firebase.initializeApp(firebaseConfig);
}*/

let dh = Dimensions.get('window').height;
let dw = Dimensions.get('window').width;
let idToSubject = ["Algebra", "Geometry", "Combinatorics", "Number Theory", "General", "Special Topics"];

export default class App extends Component {

  state = {
    // --------------------------------pages------------------------------------------
    coursesPage: 'none',
    coursesListPage: 'none',
    coursePage: 'none',
    activeCoursesPage: 'flex',
    playgroundPage: 'none',
    playgroundDataPage: 'none',
    accountPage: 'none',
    // --------------------------------timer-------------------------

    isTiming: false,
    timer: "00:00:00",
    cumValue: 0,
    lastStartTime: -1,

    // ---------------------------------courses-----------------------------------

    subjectLevelList: [
      {
        name: 'Algebra',
        id: 0,
        leftColor: colors.red100,
        rightColor: colors.red400,
      },
      {
        name: 'Geometry',
        id: 1,
        leftColor: colors.green100,
        rightColor: colors.green400,
      },
      {
        name: 'Combinatorics',
        id: 2,
        leftColor: colors.blue100,
        rightColor: colors.blue400,
      },
      {
        name: 'Number Theory',
        id: 3,
        leftColor: colors.pink100,
        rightColor: colors.pink400,
      },
      {
        name: 'General',
        id: 4,
        leftColor: colors.orange100,
        rightColor: colors.orange400,
      },
      {
        name: 'Special Topics',
        id: 5,
        leftColor: colors.yellow100,
        rightColor: colors.yellow700,
      },
    ],
    courseSubjectid: 0,
    courseSubjectLevel: 0,
    courseIndex: 0, 
    coursesList: [
      [ // Algebra
        [ // introductory
          {
            title: "A1",
            book: "AwesomeMath 105 Algebra Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 16,
            history: [],
          }
        ],
        [ // intermediate
          {
            title: "B1",
            book: "AwesomeMath 108 Algebra Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 17,
            history: [],
          }
        ],
        [ // olympiad
          {
            title: "C1",
            book: "AwesomeMath 101 Algebra Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 4,
            history: [],
          }
        ]
      ],
      [ // Geometry
        [ // introductory
          {
            title: "A1",
            book: "AwesomeMath 106 Geometry Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 5,
            history: [],
          }
        ],
        [ // intermediate
          {
            title: "B1",
            book: "Challenging Problems in Geometry",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 10,
            history: [],
          },
          {
            title: "B2",
            book: "Geometry Revisited",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 6,
            history: [],
          },
          {
            title: "B3",
            book: "AwesomeMath 107 Geometry Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 5,
            history: [],
          }
        ],
        [ // olympiad
          {
            title: "C1",
            book: "Euclidean Geometry in Mathematical Olympiads",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 10,
            history: [],
          },
          {
            title: "C2",
            book: "AwesomeMath 110 Geometry Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 2,
            history: [],
          }
        ]
      ],
      [ // Combinatorics
        [ // introductory
          {
            title: "A1",
            book: "AoPS Introduction to Counting and Probability",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 15,
            history: [],
          }
        ],
        [ // intermediate
          {
            title: "B1",
            book: "AoPS Intermediate Counting and Probability",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 16,
            history: [],
          },
          {
            title: "B2",
            book: "AwesomeMath 112 Combinatorial Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 18,
            history: [],
          }
        ],
        [ // olympiad
          {
            title: "C1",
            book: "AwesomeMath 102 Combinatorial Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 4,
            history: [],
          },
        ]
      ],
      [ // Number Theory
        [ // introductory
          {
            title: "A1",
            book: "AoPS Introduction to Number Theory",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 15,
            history: [],
          }
        ],
        [ // intermediate
          {
            title: "B1",
            book: "AoPS Intermediate Number Theory",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 12,
            history: [],
          }
        ],
        [ // olympiad
          {
            title: "C1",
            book: "Number Theory: Concepts and Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 8,
            history: [],
          },
          {
            title: "C2",
            book: "AwesomeMath 104 Number Theory Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 5,
            history: [],
          },
        ]
      ],
      [ // General
        [ // introductory
          {
            title: "A1",
            book: "AoPS Volume I",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 29,
            history: [],
          },
        ],
        [ // intermediate
          {
            title: "B1",
            book: "AoPS Volume II",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 26,
            history: [],
          },
          {
            title: "B2",
            book: "Art and Craft of Problem Solving",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 9,
            history: [],
          },
        ],
        [ // olympiad
          {
            title: "C1",
            book: "Problem Solving Strategies",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 14,
            history: [],
          },
          {
            title: "C2",
            book: "Problem Solving Through Problems",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 8,
            history: [],
          },
        ]
      ],
      [ // Special Topics
        [ // introductory
          {
            title: "I1",
            book: "AwesomeMath 109 Inequalities",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 10,
            history: [],
          },
        ],
        [ // intermediate
          {
            title: "I2",
            book: "AwesomeMath 116 Inequalities",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 2,
            history: [],
          },
        ],
        [ // olympiad
          {
            title: "P1",
            book: "Problems from the Book",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 23,
            history: [],
          },
          {
            title: "P2",
            book: "Straight from the Book",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 12,
            history: [],
          },
          {
            title: "R1",
            book: "Mathematical Reflections - The First Two Years",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "R2",
            book: "Mathematical Reflections 2008-2009",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "R2",
            book: "Mathematical Reflections 2012-2013",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "R3",
            book: "Mathematical Reflections 2014-2015",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "R4",
            book: "Mathematical Reflections 2016-2017",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "R5",
            book: "Mathematical Reflections 2018-2019",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 3,
            history: [],
          },
          {
            title: "I3",
            book: "AwesomeMath 118 Inequalities",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 2,
            history: [],
          },
          {
            title: "F1",
            book: "Topics in Functional Equations",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 19,
            history: [],
          },
          {
            title: "G1",
            book: "Lemmas in Olympiad Geometry",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 25,
            history: [],
          },
          {
            title: "GI1",
            book: "AwesomeMath 113 Geometric Inequalities",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 7,
            history: [],
          },
          {
            title: "GI2",
            book: "Topics in Geometric Inequalities",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 8,
            history: [],
          },
          {
            title: "T1",
            book: "AwesomeMath 103 Trigonometry",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 5,
            history: [],
          },
          {
            title: "GI2",
            book: "AwesomeMath 115 Trigonometry",
            isDone: false,
            isActive: false,
            isBought: false,
            chapter: 0,
            chapters: 5,
            history: [],
          },
        ]
      ]
    ],
    coursesListColors: [
      [ // Algebra
        {
          left: colors.red50,
          right: colors.red100,
        },
        {
          left: colors.red100,
          right: colors.red400,
        },
        {
          left: colors.red400,
          right: colors.red700,
        },
      ],
      [ // Geometry
        {
          left: colors.green50,
          right: colors.green100,
        },
        {
          left: colors.green100,
          right: colors.green400,
        },
        {
          left: colors.green400,
          right: colors.green700,
        },
      ],
      [ // Combinatorics
        {
          left: colors.blue50,
          right: colors.blue100,
        },
        {
          left: colors.blue100,
          right: colors.blue400,
        },
        {
          left: colors.blue400,
          right: colors.blue700,
        },
      ],
      [ // Number Theory
        {
          left: colors.pink50,
          right: colors.pink100,
        },
        {
          left: colors.pink100,
          right: colors.pink400,
        },
        {
          left: colors.pink400,
          right: colors.pink700,
        },
      ],
      [ // General
        {
          left: colors.orange50,
          right: colors.orange100,
        },
        {
          left: colors.orange100,
          right: colors.orange400,
        },
        {
          left: colors.orange400,
          right: colors.orange700,
        },
      ],
      [ // Special Topics
        {
          left: colors.yellow50,
          right: colors.yellow100,
        },
        {
          left: colors.yellow100,
          right: colors.yellow400,
        },
        {
          left: colors.yellow400,
          right: colors.yellow700,
        },
      ],
    ],

    // ----------------------------playground--------------------------------------

    playgroundData: [
      {
        title: "MMPC",
        link: '',
        level: 0,
        leftColor: colors.green50,
        rightColor: colors.green100,
        startYear: 1980,
        competitions: [
          { name: "part I", data: [] },
          { name: "part II", data: [] },
        ],

      },
      {
        title: "Math Kangaroo",
        link: 'https://www.matematica.pt/en/useful/kangaroo-questions.php',
        level: 0,
        leftColor: colors.orange50,
        rightColor: colors.orange100,
        startYear: 2009,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "AMC",
        link: 'https://artofproblemsolving.com/wiki/index.php/AMC_12_Problems_and_Solutions',
        level: 0,
        leftColor: colors.blue50,
        rightColor: colors.blue100,
        startYear: 1950,
        competitions: [
          { name: "12A", data: [] },
          { name: "12B", data: [] },
        ],
      },
      {
        title: "Mandelbrot",
        link: 'http://www.mandelbrot.org/resources/samples.html',
        level: 1,
        leftColor: colors.orange100,
        rightColor: colors.orange400,
        startYear: 2010,
        competitions: [
          { name: "Team Practice", data: [] },
          { name: "Team Tests", data: [] },
          { name: "Regional 1/2/3", data: [] },
          { name: "Regional 4/5", data: [] },
          { name: "National 1/2/3", data: [] },
          { name: "National 4/5", data: [] },
        ],
      },
      {
        title: "Lehigh",
        link: 'https://www.lehigh.edu/~dmd1/oldcontests.html',
        level: 1,
        leftColor: colors.green100,
        rightColor: colors.green400,
        startYear: 1999,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "Purple Comet",
        link: 'https://purplecomet.org/?action=resource/oldcontests',
        level: 1,
        leftColor: colors.purple100,
        rightColor: colors.purple400,
        startYear: 2003,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "CMIMC",
        link: 'https://cmimc-official.herokuapp.com/archive',
        level: 1,
        leftColor: colors.red100,
        rightColor: colors.red400,
        startYear: 2016,
        competitions: [
          { name: "Algebra/NT", data: [] },
          { name: "Combo/CS", data: [] },
          { name: "Geometry", data: [] },
          { name: "Team", data: [] },
          { name: "Power", data: [] },
          { name: "Finals", data: [] },
        ],
      },
      {
        title: "BMT",
        link: 'https://bmt.berkeley.edu/archive/',
        level: 1,
        leftColor: colors.blue100,
        rightColor: colors.blue400,
        startYear: 2012,
        competitions: [
          { name: "Algebra", data: [] },
          { name: "Geometry", data: [] },
          { name: "Discrete", data: [] },
          { name: "Calculus", data: [] },
          { name: "Individual", data: [] },
          { name: "Team", data: [] },
          { name: "Power", data: [] },
        ],
      },
      {
        title: "MPFG",
        link: 'https://mathprize.atfoundation.org/resources',
        level: 1,
        leftColor: colors.green100,
        rightColor: colors.green400,
        startYear: 2009,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "AIME",
        link: 'https://artofproblemsolving.com/wiki/index.php/AIME_Problems_and_Solutions',
        level: 1,
        leftColor: colors.blue100,
        rightColor: colors.blue400,
        startYear: 1983,
        competitions: [
          { name: "Exam I", data: [] },
          { name: "Exam II", data: [] },
        ],
      },
      {
        title: "HMMT November",
        link: 'https://www.hmmt.org/www/archive/results',
        level: 1,
        leftColor: colors.red100,
        rightColor: colors.red400,
        startYear: 2008,
        competitions: [
          { name: "General", data: [] },
          { name: "Theme", data: [] },
          { name: "Team", data: [] },
          { name: "Guts", data: [] },
        ],
      },
      {
        title: "PUMaC",
        link: 'https://pumac.princeton.edu/archives#directory',
        level: 1,
        leftColor: colors.orange100,
        rightColor: colors.orange400,
        startYear: 2007,
        competitions: [
          { name: "Algebra", data: [] },
          { name: "Combinatorics", data: [] },
          { name: "Geometry", data: [] },
          { name: "Number Theory", data: [] },
          { name: "Finals", data: [] },
          { name: "Power", data: [] },
          { name: "Team", data: [] },
          { name: "Live", data: [] },
        ],
      },
      {
        title: "ARML",
        link: 'https://www.arml.com/ARML/arml_2019/page/index.php',
        level: 1,
        leftColor: colors.blue100,
        rightColor: colors.blue400,
        startYear: 2004,
        competitions: [
          { name: "Team", data: [] },
          { name: "Power", data: [] },
          { name: "Individual", data: [] },
          { name: "Relay", data: [] },
          { name: "Super Relay", data: [] },
          { name: "Tiebreaker", data: [] },
        ],
      },
      {
        title: "SUMO",
        link: 'https://sumo.stanford.edu/smt/',
        level: 1,
        leftColor: colors.orange100,
        rightColor: colors.orange400,
        startYear: 2000,
        competitions: [
          { name: "Team", data: [] },
          { name: "Algebra", data: [] },
          { name: "Calculus", data: [] },
          { name: "Discrete", data: [] },
          { name: "Geometry", data: [] },
          { name: "General", data: [] },
          { name: "Power", data: [] },
        ],
      },
      {
        title: "USAMTS",
        link: 'https://www.usamts.org/Problems/U_ProblemsPast.php',
        level: 1,
        leftColor: colors.red100,
        rightColor: colors.red400,
        startYear: 1999,
        competitions: [
          { name: "Round 1", data: [] },
          { name: "Round 2", data: [] },
          { name: "Round 3", data: [] },
          { name: "Round 4", data: [] },
        ],
      },
      {
        title: "MPFGO",
        link: 'https://mathprize.atfoundation.org/resources',
        level: 2,
        leftColor: colors.green400,
        rightColor: colors.green700,
        startYear: 2010,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "USAJMO",
        link: 'https://artofproblemsolving.com/wiki/index.php/USAJMO_Problems_and_Solutions',
        level: 2,
        leftColor: colors.purple400,
        rightColor: colors.purple700,
        startYear: 2010,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "BAMO",
        link: 'http://www.bamo.org/archives/',
        level: 2,
        leftColor: colors.orange400,
        rightColor: colors.orange700,
        startYear: 1999,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "HMMT February",
        link: 'https://www.hmmt.org/www/archive/results',
        level: 2,
        leftColor: colors.green400,
        rightColor: colors.green700,
        startYear: 1998,
        competitions: [
          { name: "Algebra / NT", data: [] },
          { name: "Combinatorics", data: [] },
          { name: "Geometry", data: [] },
          { name: "Team", data: [] },
          { name: "Guts", data: [] },
          { name: "Calculus", data: [] },
        ],
      },
      {
        title: "ToT",
        link: 'https://www.turgor.ru/en/problems/',
        level: 2,
        leftColor: colors.blue400,
        rightColor: colors.blue700,
        startYear: 2001,
        competitions: [
          { name: "Junior O", data: [] },
          { name: "Junior A", data: [] },
          { name: "Senior O", data: [] },
          { name: "Senior A", data: [] },
        ],
      },
      {
        title: "APMO",
        link: 'https://www.apmo-official.org/problems',
        level: 2,
        leftColor: colors.green400,
        rightColor: colors.green700,
        startYear: 1989,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "HMMT Invitational",
        link: 'https://www.hmmt.org/www/archive/results',
        level: 2,
        leftColor: colors.purple400,
        rightColor: colors.purple700,
        startYear: 2013,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "NIMO",
        link: 'https://artofproblemsolving.com/community/c3158_usa_contests',
        level: 2,
        leftColor: colors.blue400,
        rightColor: colors.blue700,
        startYear: 2011,
        competitions: [
          { name: "Exam", data: [] },
          { name: "Summer Contest", data: [] },
        ],
      },
      {
        title: "OMO",
        link: 'https://artofproblemsolving.com/community/c3431_online_math_open_problems',
        level: 2,
        leftColor: colors.pink400,
        rightColor: colors.pink700,
        startYear: 2012,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
      {
        title: "EGMO",
        link: 'https://www.egmo.org/',
        level: 2,
        leftColor: colors.purple400,
        rightColor: colors.purple700,
        startYear: 2012,
        competitions: [
          { name: "Day 1", data: [] },
          { name: "Day 2", data: [] },
        ],
      },
      {
        title: "USAMO",
        link: 'https://artofproblemsolving.com/wiki/index.php/USAMO_Problems_and_Solutions',
        level: 2,
        leftColor: colors.orange400,
        rightColor: colors.orange700,
        startYear: 1972,
        competitions: [
          { name: "Day 1", data: [] },
          { name: "Day 2", data: [] },
        ],
      },
      {
        title: "ELMO",
        link: 'https://web.evanchen.cc/elmo/problems.html',
        level: 2,
        leftColor: colors.green400,
        rightColor: colors.green700,
        startYear: 2010,
        competitions: [
          { name: "ELMO", data: [] },
          { name: "ELSMO", data: [] },
          { name: "Shortlist", data: [] },
        ],
      },
      {
        title: "USA TSTST",
        link: 'https://artofproblemsolving.com/community/c3424_usa_tstst',
        level: 2,
        leftColor: colors.red400,
        rightColor: colors.red700,
        startYear: 2011,
        competitions: [
          { name: "Day 1", data: [] },
          { name: "Day 2", data: [] },
          { name: "Day 3", data: [] },
        ],
      },
      {
        title: "USA TST",
        link: 'https://artofproblemsolving.com/community/c3411_usa_team_selection_test',
        level: 2,
        leftColor: colors.purple400,
        rightColor: colors.purple700,
        startYear: 2000,
        competitions: [
          { name: "Day 1", data: [] },
          { name: "Day 2", data: [] },
        ],
      },
      {
        title: "IOI",
        link: 'https://www.imo-official.org/problems.aspx',
        level: 2,
        leftColor: colors.yellow700,
        rightColor: colors.green700,
        startYear: 1959,
        competitions: [
          { name: "Exam", data: [] },
        ],
      },
    ],

    playgroundFilter: 0,
    compIndex: 0,
    scompIndex: 0,
    endYear: 2021,
    scoreInput: "",

    coins: 0,
  }

  componentDidMount() {
    this.retrieveUserData();
  }

  retrieveUserData = () => {
    AsyncStorage.getItem("userdata")
      .then((value) => {
        if (value == null) {
          console.log("creating account");
          return;
        }
        console.log('loading account data');
        const userData = JSON.parse(value);
        this.setState({
          isTiming: userData.isTiming,
          timer: userData.timer,
          cumValue: userData.cumValue,
          lastStartTime: userData.lastStartTime,
          coins: userData.coins,
          coursesList: userData.courseData,
          playgroundData: userData.playgroundData,
        })
        setTimeout(this.updateTimer, 1000);
      }).catch((error) => {
        console.log('data was not retrieved');
        console.log(error);
      });
  }

  saveUserData = () => {
    var userData = {
      isTiming: this.state.isTiming,
      timer: this.state.timer,
      cumValue: this.state.cumValue,
      lastStartTime: this.state.lastStartTime,
      coins: this.state.coins,

      courseData: this.state.coursesList,
      playgroundData: this.state.playgroundData,
    };
    AsyncStorage.setItem("userdata", JSON.stringify(userData))
      .then(() => {
        console.log('data saved');
      }).catch((error) => {
        console.log('data was not saved');
        console.log(error);
      });
  }

  /*------------------------------------changing pages--------------------------------*/

  toNoPage = () => {
    this.setState({
      coursesPage: 'none',
      coursesListPage: 'none',
      coursePage: 'none',
      activeCoursesPage: 'none',
      activeCoursePage: 'none',
      activeCourseHistoryPage: 'none',
      playgroundPage: 'none',
      playgroundListPage: 'none',
      playgroundDataPage: 'none',
      accountPage: 'none',
    })
  }

  toCoursesPage = () => {
    this.toNoPage();
    this.setState({ coursesPage: 'flex' })
  }

  toCoursesListPage = (subjectid, subjectlevel) => {
    this.toNoPage();
    this.setState({
      courseSubjectid: subjectid,
      courseSubjectLevel: subjectlevel,
      coursesListPage: 'flex',
    })
  }

  toCoursePage = (index) => {
    this.setState({
      courseIndex: index,
    })
    this.toNoPage();
    this.setState({ coursePage: 'flex' })
  }

  toCoursePage2 = (ti, li, ci) => {
    this.setState({
      courseSubjectid: ti,
      courseSubjectLevel: li,
      courseIndex: ci,
    })
    this.toCoursePage(ci);
  }

  toActiveCoursesPage = () => {
    this.toNoPage();
    this.setState({ activeCoursesPage: 'flex' })
  }

  toPlaygroundPage = () => {
    this.toNoPage();
    this.setState({ playgroundPage: 'flex' })
  }

  toPlaygroundDataPage = (cindex, sindex) => {
    var now = new Date();
    this.setState({
      compIndex: cindex,
      scompIndex: sindex,
      endYear: now.getFullYear(),
    })

    var pdata = this.state.playgroundData;
    while (pdata[cindex].competitions[sindex].data.length < this.state.endYear-pdata[cindex].startYear+1) {
      pdata[cindex].competitions[sindex].data.splice(0, 0, {
        year: (pdata[cindex].competitions[sindex].data.length + pdata[cindex].startYear),
        state: false,
        date: "",
        length: "",
        score: "",
      })
    }

    this.setState({
      playgroundData: pdata,
    })
    this.toNoPage();
    this.setState({
      playgroundDataPage: 'flex',
    })
  }

  toAccountPage = () => {
    this.toNoPage();
    this.setState({ accountPage: 'flex' })
  }

  /* ----------------------------------timer------------------------------*/

  startTimer = () => {
    var now = new Date();
    this.setState({
      isTiming: true,
      lastStartTime: now.getTime(),
    })
    setTimeout(this.updateTimer, 20);

    setTimeout(this.saveUserData, 1000);
  }

  stopTimer = () => {
    var now = new Date();
    this.setState({
      isTiming: false,
      cumValue: Number(this.state.cumValue) + now.getTime() - this.state.lastStartTime,
    })
    clearTimeout(this.updateTimer);

    setTimeout(this.saveUserData, 1000);
  }

  updateTimer = () => {
    if (this.state.isTiming == false) return;
    //else { console.log((this.state.isTiming) + " : " + (this.state.isTiming == false)); }
    var now = new Date();
    var cur = now.getTime() - this.state.lastStartTime + this.state.cumValue;
    cur /= 1000;

    var hours = Math.floor(cur / (3600)) % 24;
    var mins = Math.floor(cur/60) % 60;
    var secs = Math.floor(cur)%60;

    var hs = hours.toString();
    if (hs.length == 1) hs = "0" + hs;
    var ms = mins.toString();
    if (ms.length == 1) ms = "0" + ms;
    var ss = secs.toString();
    if (ss.length == 1) ss = "0" + ss;

    this.setState({
      timer: hs + ":" + ms + ":" + ss,
    })

    setTimeout(this.updateTimer, 20);
  }

  resetTimer = () => {
    var now = new Date();
    this.setState({
      cumValue: 0,
      timer: "00:00:00",
      lastStartTime: now.getTime(),
    })

    setTimeout(this.saveUserData, 1000);
  }

  // ----------------------------------------courses-------------------------------

  toggleCourse = () => {
    var cl = this.state.coursesList;
    var csid = this.state.courseSubjectid, csl = this.state.courseSubjectLevel, ci = this.state.courseIndex;
    var cc = this.state.coins;
    if (cl[csid][csl][ci].isBought == false && cc < 100*(csl+1)) return;
    
    if (cl[csid][csl][ci].isBought == false && cc >= 100*(csl+1)) {
      cc -= 100*(csl+1);
      cl[csid][csl][ci].isActive = true;
      cl[csid][csl][ci].isBought = true;
    } else {
      cl[csid][csl][ci].isActive = !cl[csid][csl][ci].isActive;
    }

    this.setState({
      coursesList: cl,
      coins: cc,
    })

    setTimeout(this.saveUserData, 1000);
  }

  advanceSection = () => {
    var cl = this.state.coursesList;
    var id = this.state.courseSubjectid, sl = this.state.courseSubjectLevel, ci = this.state.courseIndex;
    if (cl[id][sl][ci].isActive == false) return;
    if (cl[id][sl][ci].chapter < cl[id][sl][ci].chapters) {
      cl[id][sl][ci].chapter++;
      var now = new Date();
      cl[id][sl][ci].history.splice(cl[id][sl][ci].history.length, 0, {
        date: (now.getMonth()+1) + "/" + now.getDate() + "/" + (now.getFullYear()%100),
        length: this.state.timer,
        chapter: cl[id][sl][ci].chapter,
        score: this.state.scoreInput,
      })
    }
    if (cl[id][sl][ci].chapter >= cl[id][sl][ci].chapters) cl[id][sl][ci].isActive = false;
    this.setState({
      coursesList: cl,
    })

    setTimeout(this.saveUserData, 1000);
  }

  revertSection = () => {
    var cl = this.state.coursesList;
    var id = this.state.courseSubjectid, sl = this.state.courseSubjectLevel, ci = this.state.courseIndex;
    if (cl[id][sl][ci].isActive == false) return;
    if (cl[id][sl][ci].chapter > 0) {
      cl[id][sl][ci].chapter--;
      cl[id][sl][ci].history.pop();
    }
    this.setState({
      coursesList: cl,
    })

    setTimeout(this.saveUserData, 1000);
  }

  // --------------------------------------playground------------------------------

  setPlaygroundFilter = (level) => {
    this.setState({
      playgroundFilter: level,
    })
  }

  openLink = (link) => {
    try { WebBrowser.openBrowserAsync(link); }
    catch { console.log("failed to open link"); }
  }

  togglePlaygroundData = (year) => {
    var idx = this.state.endYear - year;
    var pdata = this.state.playgroundData;
    var cc = this.state.coins;
    var ci = this.state.compIndex, sci = this.state.scompIndex;
    if (pdata[ci].competitions[sci].data[idx].state == false) {
      pdata[ci].competitions[sci].data[idx].state = true;
      var now = new Date();
      pdata[ci].competitions[sci].data[idx].date = (now.getMonth()+1) + "/" + now.getDate() + "/" + now.getFullYear();
      pdata[ci].competitions[sci].data[idx].length = this.state.timer;
      pdata[ci].competitions[sci].data[idx].score = this.state.scoreInput;

      cc += 5*(pdata[ci].level+1);
    } else {
      pdata[ci].competitions[sci].data[idx].state = false;
      pdata[ci].competitions[sci].data[idx].date = '';
      pdata[ci].competitions[sci].data[idx].length = '';
      pdata[ci].competitions[sci].data[idx].score = '';

      cc -= 5*(pdata[ci].level+1);
    }

    this.setState({
      playgroundData: pdata,
      coins: cc,
    })

    setTimeout(this.saveUserData, 1000);
  }


  render() {
    return (
      <View style={styles.container}>
        <View style={styles.topContainer}>
          <View style={styles.topLeftContainer}>
            <Image
              style={{ margin: 10, height: dh/25, width: dh/25 }}
              source={require('./app/assets/coin.png')}
              
            />
            <Text style={styles.coinText}>
              {this.state.coins}
            </Text>
          </View>

          <View style={styles.topRightContainer}>

            <Text style={styles.timer}>
              {this.state.timer}
            </Text>

            {this.state.isTiming==false && <TouchableOpacity
              style={styles.timerButtonContainer}
              onPress={this.startTimer}
            >
              <Image
                style={{ height: dh/25, width: dh/25, }}
                source={require('./app/assets/play.png')}
              />
            </TouchableOpacity>}

            {this.state.isTiming==true && <TouchableOpacity
              style={styles.timerButtonContainer}
              onPress={this.stopTimer}
            >
              <Image
                style={{ height: dh/25, width: dh/25, }}
                source={require('./app/assets/pause.png')}
              />
            </TouchableOpacity>}

            <TouchableOpacity
              style={styles.timerButtonContainer}
              onPress={this.resetTimer}
            >
              <Image
                style={{ height: dh/25, width: dh/25, }}
                source={require('./app/assets/restart.png')}
              />
            </TouchableOpacity>
          </View>        
        </View>

        <LinearGradient colors={['lightgrey', 'white']} style={styles.topContainerShadow}>

        </LinearGradient>

        {/* ---------------------pages------------------------------*/}

        <View style={{ display: this.state.coursesPage }}>
          <View style={styles.contentContainer}>
            {this.state.subjectLevelList.map((subject) => (
              <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}} colors={[subject.leftColor, subject.rightColor]} style={styles.courseTopicContainer}>
                <View style={styles.courseTopicTopContainer}>
                  <Text style={styles.courseTopicTopContainerText}>
                    {idToSubject[subject.id]}
                  </Text>
                </View>
                <View style={styles.courseTopicBottomContainer}>
                  <TouchableOpacity
                    style={styles.courseTopicButton}
                    onPress={() => this.toCoursesListPage(subject.id, 0)}
                  >
                    <Text style={styles.courseTopicButtonText}>
                      Introductory
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.courseTopicButton}
                    onPress={() => this.toCoursesListPage(subject.id, 1)}
                  >
                    <Text style={styles.courseTopicButtonText}>
                      Intermediate
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.courseTopicButton}
                    onPress={() => this.toCoursesListPage(subject.id, 2)}
                  >
                    <Text style={styles.courseTopicButtonText}>
                      Olympiad
                    </Text>
                  </TouchableOpacity>
                </View>
                
              </LinearGradient>
            ))}
            

          </View>
        </View>

        <View style={{ display: this.state.coursesListPage }}>
          <View style={styles.contentContainer}>
            <ScrollView contentContainerStyle={{ width: dw, alignItems: 'center', }}>
              {this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel].map((course, index) => (
                <TouchableOpacity
                  style={styles.courseCardButton}
                  onPress={() => this.toCoursePage(index)}
                >
                  <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                    colors={[this.state.coursesListColors[this.state.courseSubjectid][this.state.courseSubjectLevel].left,
                    this.state.coursesListColors[this.state.courseSubjectid][this.state.courseSubjectLevel].right]} style={styles.courseCard}
                  >
                  <View style={styles.courseCardTopContainer}>
                    <Text style={styles.courseCardTitle}>
                      {idToSubject[this.state.courseSubjectid]} {course.title}
                    </Text>
                  </View>

                  <View style={styles.courseCardMidContainer}>
                    <Text style={styles.courseCardBookText}>
                      {course.book}
                    </Text>
                  </View>

                  <View style={styles.courseCardBottomContainer}>
                    <View style={styles.courseProgressBarOutside}>
                      <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                        colors={(course.isActive==true) ? [ colors.blue400, colors.blue700] : [ colors.yellow400, colors.yellow700]}
                        style={[styles.courseProgressBarInside, {width: dw*0.90*0.80*0.95*Math.max(0.05, course.chapter/course.chapters)} ]}>

                      </LinearGradient>
                    </View>
                  </View>
                  </LinearGradient>
                </TouchableOpacity>
              ))}
            </ScrollView>
            
          </View>
        </View>

        <View style={{ display: this.state.coursePage }}>
          <View style={styles.contentContainer}>
            

            <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                colors={[this.state.coursesListColors[this.state.courseSubjectid][this.state.courseSubjectLevel].left,
                this.state.coursesListColors[this.state.courseSubjectid][this.state.courseSubjectLevel].right]} style={styles.courseTopContainer }>
              <View style={styles.courseCard}>
              <View style={styles.courseCardTopContainer}>
                <Text style={styles.courseCardTitle}>
                  {idToSubject[this.state.courseSubjectid]} {this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].title}
                </Text>
              </View>

              <View style={styles.courseCardMidContainer}>
                <Text style={styles.courseCardBookText}>
                  {this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].book} {this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].chapter}/{this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].chapters}
                </Text>
              </View>

              <View style={styles.courseCardBottomContainer}>
                <View style={styles.courseProgressBarOutside}>
                  <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                    colors={(this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].isActive==true) ? [ colors.blue400, colors.blue700] : [ colors.yellow400, colors.yellow700]}
                    style={[styles.courseProgressBarInside, {width: dw*0.90*0.80*0.95*Math.max(0.05, this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].chapter/this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].chapters)} ]}>

                  </LinearGradient>
                </View>
              </View>
              </View>
            </LinearGradient>

            <View style={styles.courseMidContainer}>
              <ScrollView>
                <View style={styles.courseHistoryContainer}>
                  <View style={styles.courseHistoryLeftContainer}>
                    <Text style={styles.courseHistoryText}>
                      Date
                    </Text>
                  </View>

                  <View style={styles.courseHistoryLMidContainer}>
                    <Text style={styles.courseHistoryText}>
                      Length
                    </Text>
                  </View>

                  <View style={styles.courseHistoryRMidContainer}>
                    <Text style={styles.courseHistoryText}>
                      Score
                    </Text>
                  </View>

                  <View style={styles.courseHistoryRightContainer}>
                    <Text style={styles.courseHistoryText}>
                      Chapter
                    </Text>
                  </View>
                </View>

                {this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].history.map((info) => (
                  <View style={styles.courseHistoryContainer}>
                    <View style={styles.courseHistoryLeftContainer}>
                      <Text style={styles.courseHistoryText}>
                        {info.date}
                      </Text>
                    </View>

                    <View style={styles.courseHistoryLMidContainer}>
                      <Text style={styles.courseHistoryText}>
                        {info.length}
                      </Text>
                    </View>

                    <View style={styles.courseHistoryLMidContainer}>
                      <Text style={styles.courseHistoryText}>
                        {info.score}
                      </Text>
                    </View>

                    <View style={styles.courseHistoryRightContainer}>
                      <Text style={styles.courseHistoryText}>
                        {info.chapter}
                      </Text>
                    </View>
                  </View>
                ))}
              </ScrollView>
              
            </View>

            <View style={styles.courseInputContainer}>
              <Text style={styles.courseInputTitle}>
                Score:
              </Text>

              <TextInput style={styles.courseInputText}
                onChangeText={scoreInput => this.setState({scoreInput})}
                value={this.state.scoreInput}
                maxLength={8}
              />
            </View>

            <View style={styles.courseBottomContainer}>
              <View style={styles.courseBottomTopContainer}>
                <TouchableOpacity
                  style={styles.courseButton}
                  onPress={this.toggleCourse}
                >
                  <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}} colors={[colors.blue100, colors.blue400]} style={styles.courseButton}>
                    <Text style={styles.courseButtonText}>
                      {(this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].isBought==false ? ((this.state.courseSubjectLevel+1)*100).toString() : (this.state.coursesList[this.state.courseSubjectid][this.state.courseSubjectLevel][this.state.courseIndex].isActive==true ? "Stop" : "Start"))}
                    </Text>
                  </LinearGradient>
                </TouchableOpacity>
              </View>

              <View style={styles.courseBottomBottomContainer}>
              <TouchableOpacity
                  style={styles.courseButton}
                  onPress={this.revertSection}
                >
                  <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}} colors={[colors.blue100, colors.blue400]} style={styles.courseButton}>
                    <Text style={styles.courseButtonText}>
                      Revert
                    </Text>
                  </LinearGradient>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.courseButton}
                  onPress={this.advanceSection}
                >
                  <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}} colors={[colors.blue100, colors.blue400]} style={styles.courseButton}>
                    <Text style={styles.courseButtonText}>
                      Complete
                    </Text>
                  </LinearGradient>
                </TouchableOpacity>
              </View>
            </View>

          </View>
        </View>

        <View style={{ display: this.state.activeCoursesPage }}>
          <View style={styles.contentContainer}>
            {this.state.coursesList.map((topic, ti) => (
              <View>
                {topic.map((level, li) => (
                  <View>
                    {level.map((course, ci) => (
                      <View>
                        {course.isActive && <TouchableOpacity
                          style={styles.courseCardButton}
                          onPress={() => this.toCoursePage2(ti, li, ci)}
                        >
                          <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                            colors={[this.state.coursesListColors[ti][li].left,
                            this.state.coursesListColors[ti][li].right]} style={styles.courseCard}
                          >
                          <View style={styles.courseCardTopContainer}>
                            <Text style={styles.courseCardTitle}>
                              {idToSubject[ti]} {course.title}
                            </Text>
                          </View>

                          <View style={styles.courseCardMidContainer}>
                            <Text style={styles.courseCardBookText}>
                              {course.book}
                            </Text>
                          </View>

                          <View style={styles.courseCardBottomContainer}>
                            <View style={styles.courseProgressBarOutside}>
                              <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                                colors={(course.isActive==true) ? [ colors.blue400, colors.blue700] : [ colors.yellow400, colors.yellow700]}
                                style={[styles.courseProgressBarInside, {width: dw*0.90*0.80*0.95*Math.max(0.05, course.chapter/course.chapters)} ]}>

                              </LinearGradient>
                            </View>
                          </View>
                          </LinearGradient>
                        </TouchableOpacity>}
                      </View>
                    ))}
                  </View>
                ))}
              </View>
            ))}
          </View>
        </View>

        <View style={{ display: this.state.playgroundPage }}>
          <View style={styles.contentContainer}>
            <View style={styles.playgroundTopContainer} contentContainerStyle={{ width: dw, }}>
              <ScrollView nestedScrollEnabled={true}>
                {this.state.playgroundData.map((competition, cindex) => (
                  <View>
                    {competition.level==this.state.playgroundFilter &&
                    <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
                      colors={[competition.leftColor, competition.rightColor]}
                      style={styles.playgroundBand}
                    >
                      <View style={styles.playgroundBandLeftContainer}>
                        <ScrollView nestedScrollEnabled={true} contentContainerStyle={{ width: dw*0.4, alignItems: 'center', }}>
                          {competition.competitions.map((scomp, sindex) => (
                            <TouchableOpacity
                              style={styles.playgroundBandButton}
                              onPress={() => this.toPlaygroundDataPage(cindex, sindex)}
                            >
                              <Text style={styles.playgroundBandButtonText}>
                                {scomp.name}
                              </Text>
                            </TouchableOpacity>
                          ))}
                        </ScrollView>
                      </View>

                      <View style={styles.playgroundBandRightContainer}>
                        <Text style={styles.playgroundBandTitle}>
                          {competition.title}
                        </Text>

                        <TouchableOpacity
                          style={styles.playgroundBandLinkButton}
                          onPress={() => this.openLink(competition.link)}
                        >
                          <Text style={styles.playgroundBandLinkButtonText}>
                            Archive
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </LinearGradient>}
                  </View>
                ))}
              </ScrollView>
            </View>

            <View style={styles.playgroundBottomContainer}>
              <TouchableOpacity
                style={styles.playgroundButtonFilter}
                onPress={() => this.setPlaygroundFilter(0)}
              >
                <Text style={styles.playgroundButtonFilterText}>
                  Introductory
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.playgroundButtonFilter}
                onPress={() => this.setPlaygroundFilter(1)}
              >
                <Text style={styles.playgroundButtonFilterText}>
                  Intermediate
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.playgroundButtonFilter}
                onPress={() => this.setPlaygroundFilter(2)}
              >
                <Text style={styles.playgroundButtonFilterText}>
                  Olympiad
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>

        <View style={{ display: this.state.playgroundDataPage }}>
          <View style={styles.contentContainer}>
            <LinearGradient start={{x: 0, y: 0}} end={{x: 1, y: 0}}
              colors={[this.state.playgroundData[this.state.compIndex].leftColor, this.state.playgroundData[this.state.compIndex].rightColor]}
              style={styles.playgroundDataPageTopContainer}
            >
              <Text style={styles.playgroundDataPageTitle}>
                {this.state.playgroundData[this.state.compIndex].title} {this.state.playgroundData[this.state.compIndex].competitions[this.state.scompIndex].name}
              </Text>
            </LinearGradient>

            <View style={styles.playgroundDataPageBottomContainer}>
              <ScrollView>
                <View style={styles.playgroundDataContainer}>
                  <View style={styles.playgroundDataSmallContainer}>
                    <Text style={styles.playgroundDataText}>
                      Year
                    </Text>
                  </View>

                  <View style={styles.playgroundDataSmallContainer}>
                    <Text style={styles.playgroundDataText}>
                      Date
                    </Text>
                  </View>

                  <View style={styles.playgroundDataSmallContainer}>
                    <Text style={styles.playgroundDataText}>
                      Length
                    </Text>
                  </View>

                  <View style={styles.playgroundDataSmallContainer}>
                    <Text style={styles.playgroundDataText}>
                      Score
                    </Text>
                  </View>

                  <View style={styles.playgroundDataSmallContainer}>
                    <Text style={styles.playgroundDataText}>
                      State
                    </Text>
                  </View>

                </View>

                {this.state.playgroundData[this.state.compIndex].competitions[this.state.scompIndex].data.map((ydata) => (
                  <View style={styles.playgroundDataContainer}>
                    <View style={styles.playgroundDataSmallContainer}>
                      <Text style={styles.playgroundDataText}>
                        {ydata.year}
                      </Text>
                    </View>

                    <View style={styles.playgroundDataSmallContainer}>
                      <Text style={styles.playgroundDataText}>
                        {ydata.date}
                      </Text>
                    </View>

                    <View style={styles.playgroundDataSmallContainer}>
                      <Text style={styles.playgroundDataText}>
                        {ydata.length}
                      </Text>
                    </View>

                    <View style={styles.playgroundDataSmallContainer}>
                      <Text style={styles.playgroundDataText}>
                        {ydata.score}
                      </Text>
                    </View>

                    <View style={styles.playgroundDataSmallContainer}>
                      <TouchableOpacity
                        style={[styles.playgroundDataCheckbox, ydata.state==true ? styles.checkBoxOn : styles.checkBoxOff]}
                        onPress={() => this.togglePlaygroundData(ydata.year)}
                      >

                      </TouchableOpacity>
                    </View>

                  </View>
                ))}
              </ScrollView>
            </View>

            <View style={styles.courseInputContainer}>
              <Text style={styles.courseInputTitle}>
                Score:
              </Text>

              <TextInput style={styles.courseInputText}
                onChangeText={scoreInput => this.setState({scoreInput})}
                value={this.state.scoreInput}
                maxLength={8}
              />
            </View>

          </View>
        </View>

        <View style={{ display: this.state.accountPage }}>
          <View style={styles.contentContainer}>
            <Text style={{ fontSize: dh*0.02, }}> Coming Soon! </Text>
            
          </View>
        </View>

        {/*-----------------------navbar---------------------------------*/}

        <LinearGradient colors={['white', 'lightgrey']} style={styles.navbarShadow}>
          
        </LinearGradient>

        <View style={styles.navbar}>
          <TouchableOpacity
            style={styles.navButtonContainer}
            onPress={this.toCoursesPage}
          >
            <Image
              style={styles.navButton}
              source={require('./app/assets/brain.png')}
            />
          </TouchableOpacity>
          
          <TouchableOpacity
            style={styles.navButtonContainer}
            onPress={this.toActiveCoursesPage}
          >
            <Image
              style={styles.navButton}
              source={require('./app/assets/book.png')}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.navButtonContainer}
            onPress={this.toPlaygroundPage}
          >
            <Image
              style={styles.navButton}
              source={require('./app/assets/slide.png')}
            />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.navButtonContainer}
            onPress={this.toAccountPage}
          >
            <Image
              style={styles.navButton}
              source={require('./app/assets/user.png')}
            />
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  // ----------------------------------main styles--------------------------------------
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white', //colors.orange400,
  },

  topContainer: {
    height: "7%",
    width: "100%",
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: 'white',
    //shadow
  },

  topContainerShadow: {
    height: "0.5%",
    width: "100%",
  },

  topLeftContainer: {
    width: "50%",
    height: "100%",
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    //backgroundColor: colors.orange100,
  },

  topRightContainer: {
    width: "50%",
    height: "100%",
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    //backgroundColor: colors.green100,
  },

  contentContainer: {
    height: dh*82.5/100,
    width: dw,
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  navbarShadow: {
    height: "0.5%",
    width: "100%",
  },

  navbar: {
    height: "9.5%",
    width: "100%",
    backgroundColor: 'white',
    //borderTopWidth: 5,
    //borderTopColor: 'grey',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    
    //elevation: 2,
  },

  navButtonContainer: {
    width: "25%",
    height: "100%",
    alignItems: 'center',
    justifyContent: 'center',
    //backgroundColor: '#DDDDDD',
    //underlayColor: 'yellow',
  },

  navButton: {
    height: dh/20,
    width: dh/20,
  },

  coinText: {
    fontWeight: 'bold',
    fontSize: dh*7.5/100 * 0.35,
    color: colors.pink400,
  },

  timer: {
    fontWeight: 'bold',
    fontSize: dh*7.5/100*0.35,
    color: 'grey',
  },

  timerButtonContainer: {
    height: dh*7.5/100,
    width: dh*7.5/100,
    alignItems: 'center',
    justifyContent: 'center',
  },

  test: {
    width: 200,
    height: 100,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },

  // -----------------------------courses page---------------------------------------

  courseTopicContainer: {
    height: "16.66666%", //dh*87.5/100 * 1/6,
    width: "100%",
    alignItems: 'center',
  },

  courseTopicTopContainer: {
    height: "50%", //dh*87.5/100 * 1/6 * 1/2,
    width: "100%",
    justifyContent: 'center',
    alignItems: 'flex-end',
    padding: 15,
  },

  courseTopicTopContainerText: {
    fontSize: dh*87.5/100 * 1/6 *1/2 * 0.5,
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },

  courseTopicBottomContainer: {
    height: "50%",
    width: "100%",
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },

  courseTopicButton: {
    height: "50%",
    width: "25%",
    borderRadius: 5,
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseTopicButtonText: {
    fontSize: dh*87.5/100 * 1/6 * 1/2 *5/10 * 0.5,
    fontWeight: 'bold',
  },

  courseCardButton: {
    height: dh*0.20,
    width: dw*0.9,
    marginTop: dh*0.02,
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseCard: {
    height:dh*0.20,
    width: dw*0.9,
    borderRadius: dw*0.05,
    
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseCardTitle: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: dh*0.20 * 0.40*0.5,
    marginRight: dw*0.05,
  },

  courseCardBookText: {
    fontWeight: 'bold',
    color: 'white', //'grey',
    fontSize: dh*0.20*0.20*0.50,
    marginRight: dw*0.05,
  },

  courseCardTopContainer: {
    height: "40%",
    width: "100%",
    alignItems: 'flex-end',
    justifyContent: 'center',
  },

  courseCardMidContainer: {
    height: "20%",
    width: "100%",
    alignItems: 'flex-end',
    justifyContent: 'center',
  },

  courseCardBottomContainer: {
    height: "40%",
    width: "100%",
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseProgressBarOutside: {
    height: "50%",
    width: "80%",
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderRadius: dh*0.20*0.40*0.50,
  },

  courseProgressBarInside: {
    height: "60%", //dh*0.20*0.40*0.50*0.9,
    borderRadius: dh*0.20*0.40*0.50*0.60,
    marginLeft: "2.5%",
    //width: dw*0.90*0.80*0.95,
  },

  //--------------------------------course page---------------------------------

  courseTopContainer: {
    height: dh*0.25,
    width: dw,
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseTitle: {
    fontSize: dh*0.20*0.4*0.50,
    color: 'white',
    fontWeight: 'bold',
  },

  courseMidContainer: {
    height: dh*0.40,
    width: dw,
    borderTopWidth: 1,
    borderColor: 'grey',
    borderBottomWidth: 1,
  },

  courseHistoryContainer: {
    height: dh*0.05,
    width: dw,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseHistoryLeftContainer: {
    height: dh*0.05,
    width: "25%",
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseHistoryLMidContainer: {
    height: dh*0.05,
    width: "25%",
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseHistoryRMidContainer: {
    height: dh*0.05,
    width: "25%",
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseHistoryRightContainer: {
    height: dh*0.05,
    width: "25%",
    alignItems: 'center',
    justifyContent: 'center',
    //borderWidth: 1,
  },

  courseHistoryTextTitle: {
    fontSize: dh*0.05*0.40,
    fontWeight: 'bold',
    color: 'black',
  },

  courseHistoryText: {
    fontSize: dh*0.05*0.40,
    fontWeight: 'bold',
    color: 'grey',
  },

  courseInputContainer: {
    height: dh*0.05,
    width: dw,
    borderBottomWidth: 1,
    borderBottomColor: 'grey',
    borderTopWidth: 1,
    borderTopColor: 'grey',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  courseInputTitle: {
    fontSize: dh*0.05*0.4,
    fontWeight: 'bold',
    color: 'black',
    marginLeft: dw*0.1,
  },

  courseInputText: {
    width: dw*0.7,
    fontSize: dh*0.05*0.4,
    fontWeight: 'bold',
    color: 'black',
    //backgroundColor: 'lightblue',
    borderWidth: 1,
    borderColor: 'lightgrey',
    marginLeft: dw*0.02,
  },

  courseBottomContainer: {
    height: dh*0.125,
    width: dw,
  },

  courseBottomTopContainer: {
    height: dh*0.0625,
    width: dw,
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseBottomBottomContainer: {
    height: dh*0.0625,
    width: dw,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },

  courseButton: {
    height: dh*0.05,
    borderRadius: dh*0.05,
    width: dw*0.3,
    alignItems: 'center',
    justifyContent: 'center',
  },

  courseButtonText: {
    fontSize: dh*0.05*0.4,
    color: 'white',
    fontWeight: 'bold',
  },

  //-------------playground------------------------------------

  playgroundTopContainer: {
    height: dh*0.825*0.9,
    width: "100%",
    justifyContent: 'flex-start',
    alignItems: 'center',
  },

  playgroundBottomContainer: {
    height: dh*0.825*0.1,
    width: "100%",
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    borderTopWidth: 1,
    borderTopColor: 'grey',
  },

  playgroundButtonFilter: {
    height: dh*0.825*0.1,
    width: dw/3,
    alignItems: 'center',
    justifyContent: 'center',
  },

  playgroundButtonFilterText: {
    fontSize: dh*0.825*0.1*0.25,
    fontWeight: 'bold',
    color: 'grey',
  },

  playgroundBand: {
    width: dw,
    height: dh*0.15,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },

  playgroundBandRightContainer: {
    height: dh*0.15,
    width: dw*0.6,
    alignItems: 'flex-end',
    justifyContent: 'space-evenly',
    //backgroundColor: 'red',
  },

  playgroundBandLeftContainer: {
    height: dh*0.125,
    width: dw*0.4,
    alignItems: 'center',
    justifyContent: 'center',
    //borderRightWidth: 2,
    //borderRightColor: 'lightgrey',
  },

  playgroundBandTitle: {
    fontSize: dh*0.15*0.2,
    color: 'white',
    fontWeight: 'bold',
    marginRight: dh*0.15*0.2,
    //marginTop: dh*0.15*0.2,
  },

   playgroundBandLinkButton: {
     height: dh*0.15*0.4,
     borderRadius: dh*0.15*0.4*0.25,
     width: dw*0.6*0.6,
     alignItems: 'center',
     justifyContent: 'center',
     backgroundColor: 'white',
     marginRight: dh*0.15*0.2,
   },

   playgroundBandLinkButtonText: {
     fontSize: dh*0.15*0.4*0.35,
     color: 'black',
   },

  playgroundBandButton: {
    height: dh*0.15*0.3,
    width: dw*0.4*0.8,
    borderRadius: dh*0.15*0.3,
    marginTop: dh*0.15*0.3*0.2,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.orange400,
  },

  playgroundBandButtonText: {
    fontSize: dh*0.15*0.3*0.4,
    color: 'white',
    fontWeight: 'bold',
  },

  playgroundDataPageTopContainer: {
    height: dh*0.825*0.1,
    width: dw,
    alignItems: 'center',
    justifyContent: 'center',
  },

  playgroundDataPageTitle: {
    fontSize: dh*0.825*0.1*0.4,
    fontWeight: 'bold',
    color: 'white',
  },

  playgroundDataPageBottomContainer: {
    height: dh*0.825*0.9 - dh*0.05,
    width: dw,
    //alignItems: 'center',
  },

  playgroundDataContainer: {
    height: dh*0.05,
    width: dw,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    //borderWidth: 1,
  },

  playgroundDataSmallContainer: {
    height: dh*0.05,
    width: dw*0.20,
    alignItems: 'center',
    justifyContent: 'center',
    //borderWidth: 1,
  },

  playgroundDataText: {
    fontSize: dh*0.05*0.40,
    fontWeight: 'bold',
    color: 'grey',
  },

  playgroundDataCheckbox: {
    width: dh*0.05*0.7,
    height: dh*0.05*0.7,
    borderWidth: 3,
    borderColor: 'black',
  },

  checkBoxOn: {
    backgroundColor: colors.blue100,
  },

  checkBoxOff: {
    backgroundColor: 'white',
  },

});
